class UrgencyBanner extends CustomElement {
  props = {
    targetDate: '',
  }

  get refs() {
    return {
      countdown: this.$el.find('[data-urgency-countdown]'),
      timer: this.$el.find('[data-urgency-timer]'),
    }
  }

  mounted() {
    super.mounted()

    const { targetDate } = this.props

    if (!targetDate) {
      this.$el.removeClass('hidden')
      return
    }

    const endTime = new Date(targetDate.replace(' ', 'T'))
    let delta = isNaN(endTime.getTime()) ? -1 : (endTime.getTime() - Date.now()) / 1000

    if (delta <= 0) {
      this._expireTimer()
      return
    }

    this._tick(delta)
    this.$el.removeClass('hidden')

    this._interval = setInterval(() => {
      delta -= 1
      this._tick(delta)
    }, 1000)
  }

  _tick(delta) {
    if (delta <= 0) {
      this._expireTimer()
      return
    }

    const [days, hours, minutes, seconds] = getTimeParts(delta)
    this.refs.countdown.text(`${days}日 ${hours}時 ${minutes}分 ${seconds}秒`)
  }

  _expireTimer() {
    clearInterval(this._interval)
    this.refs.timer.remove()
    this.$el.addClass('hidden')
  }

  onDestroy() {
    clearInterval(this._interval)
  }
}

if (!customElements.get('urgency-banner')) {
  customElements.define('urgency-banner', UrgencyBanner)
}
